<template>
  <nav class="item-navigation">
    <router-link class="prev" v-if="prev" :to="`/${model}/${prev.slug}`">&lt; {{prev.name}}</router-link>
    <router-link class="next" v-if="next" :to="`/${model}/${next.slug}`">{{next.name}} &gt;</router-link>
  </nav>
</template>

<script>
export default {
  name: 'ItemNavigation',
  props: {
    prev: {
      type: Object,
      default: () => ({}),
    },
    next: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.item-navigation {
  width: 100%;
  // background-color: #fff;
  padding: 10px;
  overflow: hidden;

  a {
    display: block;
    text-decoration: none;
    padding: 5px;

    &:hover {
      text-decoration: underline;
    }

    &.prev {
      float: left;
    }

    &.next {
      float: right;
    }
  }
}
</style>
